import { ActionModal, useRouter, useSnackbar } from '@forgeglobal/design-framework'
import {
  ApplyOpportunityActionMutationVariables,
  MinimalOpportunitiesDocument,
  TradeIntentStatusType,
  TradeIntentType,
  useApplyOpportunityActionMutation,
  useOpportunityQuery,
} from 'graphql/bindings/AdminBindings'
import { Routes } from 'util/Routes'
import React, { Fragment } from 'react'
import compact from 'lodash/compact'

export const DeleteOpportunityModal: React.FC<{
  hideModal: () => void
  opportunityId: string
  pageSource: 'opportunityDetails' | 'account' | 'issuer'
}> = ({ hideModal, opportunityId, pageSource }) => {
  const { history } = useRouter()
  const { enqueueSnackbar } = useSnackbar()
  const { data: opportunityData } = useOpportunityQuery({ variables: { id: opportunityId }, skip: !opportunityId })
  const opportunity = opportunityData?.opportunity

  const [mutate] = useApplyOpportunityActionMutation({
    refetchQueries: compact([
      opportunity?.account_id && {
        query: MinimalOpportunitiesDocument,
        variables: { accountId: opportunity?.account_id },
      },
      opportunity?.company.crm_account.id && {
        query: MinimalOpportunitiesDocument,
        variables: { accountId: opportunity?.company.crm_account.id },
      },
    ]),
  })

  const onSubmit = () => {
    const variables: ApplyOpportunityActionMutationVariables = {
      form: {
        opportunityId: opportunity?.id,
        status: TradeIntentStatusType.Deleted,
      },
    }
    mutate({ variables }).then(() => {
      hideModal()
      if (pageSource === 'opportunityDetails') {
        history.push(Routes.account(`${opportunity?.account_id}/opportunities`))
      }
      enqueueSnackbar('Opportunity deleted')
    })
  }

  const deletable = opportunity?.source && opportunity?.source !== 'platform_user'

  if (!opportunity) return null //loading

  const opportunityType = opportunity?.type === TradeIntentType.Bid ? 'Bid' : 'Ask'

  return (
    <ActionModal
      open
      hideModal={hideModal}
      title={`Delete ${opportunityType}`}
      cancelAction={hideModal}
      confirmAction={onSubmit}
      positiveMessage={'Yes'}
      negativeMessage={'No'}
      header={deletable ? 'Are you sure?' : ''}
      actionMessage={
        deletable ? (
          'Opportunities should only be deleted for invalid data that was accidentally entered.'
        ) : (
          <Fragment>This is a user-created {opportunity.type} and cannot be deleted.</Fragment>
        )
      }
    />
  )
}
